import { T } from "../../util/t";
import { useWatch } from "react-hook-form";
import { calculateTotal } from "./paidRegistrationUtils";
import { LocalOffer } from "@mui/icons-material";
import { WizardSummaryBox } from "../forms/wizard/WizardSummaryBox";
import { WaitlistedRegistrationExplainer } from "./WaitlistedRegistrationExplainer";

export const RegistrationSummary = ({ control, paymentOptions, registrationOptions, isSeriesRegistration }) => {
    const athletes = useWatch({ name: "athletes", control });
    const [regoDivisions, regoAthletes] = athletes.reduce(([regoDivisions, regoAthletes], athlete) => {
        const athleteDivisions = athlete.registrations_attributes.filter(rego => !rego.id).length;
        return [regoDivisions + athleteDivisions, regoAthletes + (athleteDivisions > 0 ? 1 : 0)];
    }, [0, 0]);
    const hasExtras = paymentOptions?.extras?.length > 0;
    const [regoExtras, extraAthletes] = hasExtras ? athletes.reduce(([regoExtras, extraAthletes], athlete) => {
        const athleteExtras = athlete.extras?.length || 0;
        return [regoExtras + athleteExtras, extraAthletes + (athleteExtras > 0 ? 1 : 0)];
    }, [0, 0]) : [];
    const currency = paymentOptions?.currency;
    const registrationTotals = paymentOptions && calculateTotal(athletes, paymentOptions);
    const discountLabel = isSeriesRegistration ? "Family discount" : "Group discount";

    return (
        <WizardSummaryBox
            title="Summary"
            lineItems={[
                {
                    text: isSeriesRegistration ?
                        <T athletes={regoAthletes} divisions={regoDivisions}>membership_options_athletes_summary</T> :
                        <T athletes={regoAthletes} divisions={regoDivisions}>divisions_entries_summary</T>,
                    total: registrationTotals && (registrationTotals.subtotalWithoutFamilyDiscount - registrationTotals.extras)
                },
                hasExtras && {
                    text: <T athletes={extraAthletes} extras={regoExtras}>extras_athletes_summary</T>,
                    total: registrationTotals.extras
                },
                registrationTotals && registrationTotals.subtotalWithoutFamilyDiscount !== registrationTotals.total && {
                    text: <><T>{discountLabel}</T> <LocalOffer fontSize="inherit" /></>,
                    total: -(registrationTotals.subtotalWithoutFamilyDiscount - registrationTotals.total)
                }
            ].filter(i => i)}
            total={registrationTotals?.total}
            currency={currency}
            discount={registrationTotals && registrationOptions?.waitlisted && { text: <WaitlistedRegistrationExplainer /> }}
        />
    );
};
